// API client — talks to our backend
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  const json = await res.json();
  if (!json.success) throw new Error(json.error || 'API error');
  return json.data;
}

export const api = {
  dashboard:       ()             => get('/dashboard'),
  brands:          ()             => get('/brands'),
  analytics:       (days = 30)   => get(`/analytics?days=${days}`),
  brandCampaigns:  (id, days=30) => get(`/brands/${id}/campaigns?days=${days}&limit=50`),
  brandTrend:      (id, days=30) => get(`/brands/${id}/trend?days=${days}`),
  campaign:        (id)          => get(`/campaigns/${id}`),
  search:          (q)           => get(`/search?q=${encodeURIComponent(q)}`),
};
